import {VGNav} from "vgnav";
import {VGLawCookie} from "vglawcookie";
import {VGRollup} from "vgrollup";
import VGMap from "../../../../modules/vegas/js/map";
import YandexMap from "./modules/map/YandexMap";
import VGSidebar from "vgnav/src/VGSidebar/js/VGSidebar";

const VGListener = {
	onReady: () => {
		VG.defaults();
		VG.clone();
		VG.plugins.init();
		VG.ScrollToTop.init($(window));
		VG.ScrollHeader.init($(window));
		VG.ScrollLoad.yaMap('#yaMapHome');

		// [vegas]
		VG.log();
	},

	onLoad: () => {

	},

	onScroll: ($self) => {
		VG.ScrollHeader.init($self);
		VG.ScrollToTop.setPosition($self);
		VG.ScrollLoad.yaMap('#yaMapHome');
	},

	onResize: ($self) => {
		VG.clone();
	},
}

const VG = {
	log: function (errors = []) {
		if (!errors.length) {
			console.log("%cVG app was initialization", "color: green;");
		} else {
			errors.forEach(function (item) {
				console.error(item);
			});
		}
	},

	defaults: () => {
		// Манипуляции с контентом по умолчанию
		$('.vg-page-default, .page-default').each(function () {
			let $self = $(this);

			// Table
			let $table = $self.find('table');
			$table.addClass('table table-hover table-bordered');
			$table.wrap('<div class="table-responsive"></div>');

			// image
			$self.find('img').addClass('img-fluid');

			$self.find('a[href=""][data-fancybox] > img').each(function () {
				$(this).closest('a').attr('href', $(this).attr('src'));
			});

			// AOS
			if (enables.scrollAnimation) {
				if (typeof $self.attr('data-aos-start') !== typeof undefined && $self.attr('data-aos-start') !== false) {
					let $tags = ['p', 'li', 'h2', 'h3'],
						start = parseInt($self.data('aos-start')),
						step = 100;

					for (let i = 1; i <= $tags.length; i++) {
						let tag = $tags[i - 1],
							$tag = $self.find(tag);

						if ($tag.length) {
							$.each($tag, function () {
								start = start + step;
								$(this).attr('data-aos', 'fade-up');
								$(this).attr('data-aos-delay', start);
							});
						}
					}

					AOS.init();
				}
			}

			//
			let modalBuyTechnique = document.getElementById('modal-buy-technique');
			if (modalBuyTechnique) {
				modalBuyTechnique.addEventListener('show.bs.modal', function (event) {
					let $sidebar = document.querySelector('.vg-sidebar.open');
					if ($sidebar) {
						let sidebar = new VGSidebar($sidebar.id);
						sidebar.close();
					}
				})
			}
		});
	},

	clone: () => {
		if (window.innerWidth < 1199) {
			let $obj_filters_clone = $('.catalog-filters--clone');
			if ($obj_filters_clone.length) {
				$obj_filters_clone.clone(true).detach();
				$('.catalog-sidebar--clone-filters').append($obj_filters_clone)
			}

			/*let $obj_categories_clone;
			$obj_categories_clone = $('.catalog-categories--main');
			if (!$obj_categories_clone.length) $obj_categories_clone = $('.list-categories');

			if ($obj_categories_clone.length) {
				$obj_categories_clone.clone(true).detach();
				$('#vg-catalog-sidebar--clone').append($obj_categories_clone)
			}*/
		}
	},

	plugins: {
		init: () => {
			VG.plugins.enableAOS();
			VG.plugins.enableNiceSelect();
			VG.plugins.enableVGNav();
			VG.plugins.enableLawCookie();
			VG.plugins.enableRollup();
		},

		enableVGNav: function () {
			new VGNav({
				hover: true,
				expand: 'lg',
				toggle: '<i class="fa fa-chevron-down"></i>'
			});
		},

		enableAOS: function () {
			if (enables.scrollAnimation) {
				AOS.init({once: true});
			}
		},

		enableNiceSelect: function () {
			$('.nice-select').niceSelect();
		},

		enableLawCookie: function () {
			return new VGLawCookie({
				enableCookie: true,
				cookie: {
					attributes: {
						domain: App.domain
					}
				}
			});
		},

		enableRollup: function () {
			[... document.querySelectorAll('[data-rollup-content]')].forEach((element) => {
				let target = element.id,
					content = element.dataset.rollupContent || 'text';

				new VGRollup(target, {
					content: content
				}, {
					afterShow: function () {
						// coming soon
					},
					afterHide: function () {
						// coming soon
					}
				});
			});
		}
	},

	ScrollHeader: {
		lastScrollTop: 0,
		body: $('body'),
		stickyArea: $('.sticky-area'),
		height: {
			window: window.innerHeight,
			wrapper: $('.wrapper').height(),
			sticky: $('.header-fixed').height()
		},

		init: function ($window) {
			let $sticky = $('.header-wrapper'),
				scroll = $window.scrollTop();

			if ((this.height.window + this.height.sticky + 50) > this.height.wrapper) return;

			if (scroll > 0) {
				$sticky.addClass('hide');
				this.body.addClass('header--is-hide');
			} else {
				$sticky.removeClass('hide');
				this.body.removeClass('header--is-hide');
			}

			/*if (scroll > 134) {
				this.body.addClass('header--is-scroll');
				$sticky.addClass('scroll');

				if (scroll > this.lastScrollTop) {
					$sticky.removeClass('fixed');
					this.body.removeClass('header--is-fixed');
					this.stickyArea.removeClass('fixed');
				} else {
					$sticky.addClass('fixed');
					this.body.addClass('header--is-fixed');
					this.stickyArea.addClass('fixed');
				}

				this.lastScrollTop = scroll;
			} else if (scroll < 134) {
				$sticky.removeClass('scroll').removeClass('fixed');
				this.body.removeClass('header--is-scroll header--is-fixed');
			}*/

			// widgets-sticky scroll
			let $widgetsSticky = $('.widgets-sticky, .sticky-top, .sticky-area');
			if ($widgetsSticky.length) {
				if (this.body.hasClass('header--is-hide')) {
					$widgetsSticky.css('top', 96);
				} else {
					$widgetsSticky.css('top', 16);
				}
			}
		},
	},

	ScrollToTop: {
		posActive: 400,
		btn: 'btn-scroll-to-top',

		init: function ($window) {
			let $layoutScrollToTop = $('#' + this.btn);

			if (!$layoutScrollToTop.length) {
				$('body').append('<div class="to-top" id="' + this.btn + '"><span><i class="fal fa-chevron-up"></i></span></div>')

				this.setPosition($window);
			}

			let $btnScrollToTop = $('#' + this.btn + ' span');
			$btnScrollToTop.click(function () {
				window.scrollTo(0, 0);

				return false;
			});
		},

		setPosition: function ($window) {
			let $sticky = $('#' + this.btn),
				scroll = $window.scrollTop();

			if (scroll >= this.posActive) {
				$sticky.addClass('is-active');
			} else {
				$sticky.removeClass('is-active');
			}
		}
	},

	ScrollLoad: {
		isInit: false,
		yaMap: function (map) {
			let $map = document.querySelector(map);

			if ($map) {
				let offsetTop = $map.getBoundingClientRect().top,
					windowHeight = window.innerHeight,
					offset = offsetTop - windowHeight;

				if (offset < 100 && !this.isInit) {
					new YandexMap().loadIfVisible($map, () => {
						VGMap.init($map, {
							callback: {
								afterInitMap: function (map, params, _this) {
									_this.PlaceMark.set(map, params);
								}
							}
						});
					});

					this.isInit = true;
				}
			}
		}
	}
}


export default VGListener;
